<template>
    <div class="content">
        <div>
            <div id="realtime-porject-type"></div>
        </div>
        <!--        <div>-->
        <div id="realtime-type-bar">
            <!--            <ul>-->
            <!--                <li v-for="dat in datas" :key="dat.id">{{dat}}</li>-->
            <!--            </ul>-->
            <!--            </div>-->
        </div>
    </div>
</template>

<script>
    import echarts from 'echarts';
    import {CreditPorjectRealtimeType} from "../../../../network/projectAnalysis";

    export default {
        name: "DayTypeBarv2",
        data() {
            return {
                myChart: '',
                series: '',
                option: {
                    title: [
                        {
                            text: '24H行业统计',
                            textStyle: {
                                fontSize: 16,
                                color: "#f7f7b6",
                            },
                            left: "middle",
                            top: 100,
                            textAlign: "center"
                        },
                        {
                            text: '外圈：主要行业\n\n内圈：细分行业',

                            textStyle: {
                                fontSize: 14,
                                color: "#f7f7b6"
                            },

                            textAlign: "center",
                            left: 150,
                            top: 150,
                        }],
                    toolbox: {
                        feature: {
                            saveAsImage: {
                                pixelRatio: 2
                            },

                        },
                        iconStyle: {
                            borderColor: '#f7f7b6'
                        },
                        top: 100,
                        right: 240,
                    },
                    tooltip: {
                        trigger: 'item',
                        position: 'right',
                        formatter: function (parms) {
                            var str = parms.seriesName + "</br>" +
                                parms.marker + "" + parms.data.legendname + "</br>" +
                                "数量：" + parms.data.value + "</br>" +
                                "占比：" + parms.percent + "%";
                            return str;
                        }
                    },
                    color: ["#EDE68B","#62f5a5", "#52dbf5", "#F7596A", "#f5ddaf", "#edebef", "#D0688C"],
                    legend: {
                        type: "scroll",
                        orient: 'vertical',
                        // right: -90,
                        left: "78%",
                        top: 170,
                        textStyle: {
                            color: "#f7f7b6",
                            fontSize: 14,
                        },
                        height: 700,



                    },
                    series: [
                        {
                            name: '主行业',
                            type: 'pie',
                            // roseType: true,
                            // minAngle: 30,
                            minShowLabelAngle: 5,
                            center: ['40%', '55%'],
                            radius: ['35%', '65%'],
                            clockwise: false, //饼图的扇区是否是顺时针排布
                            avoidLabelOverlap: false,
                            label: {
                                normal: {
                                    show: true,
                                    fontSize: 14,
                                    fontWeight: "bold",
                                    position: 'outside',
                                    formatter: function (parms) {
                                        return parms.data.legendname.slice(0, 8)
                                    }
                                }
                            },
                            labelLine: {
                                normal: {
                                    length: 5,
                                    length2: 3,
                                    smooth: true,
                                }
                            },
                            // data: m2R2Data
                        },
                        {
                            name: '细分行业',
                            type: 'pie',
                            // radius: '55%',
                            center: ['40%', '55%'],
                            radius: ['5%', '25%'],
                            clockwise: false, //饼图的扇区是否是顺时针排布
                            minShowLabelAngle: 15,
                            data: [].sort(function (a, b) {
                                return a.value - b.value;
                            }),
                            label: {
                                color: "#8414f7",
                                 textBorderColor: "auto",
                                show: true,
                                fontSize: 14,
                                fontWeight: "bold",
                                position: 'inside',
                                formatter: function (parms) {
                                    return parms.data.name.slice(0, 8)
                                }
                            },
                            labelLine: {
                                normal: {
                                    length: 5,
                                    length2: 3,
                                    smooth: true,
                                }
                            },
                            // itemStyle: {
                            //     color: '#c23531',
                            //     shadowBlur: 200,
                            //     shadowColor: 'rgba(0, 0, 0, 0.5)'
                            // },

                            animationType: 'scale',
                            animationEasing: 'elasticOut',
                            animationDelay: function () {
                                return Math.random() * 200;
                            }
                        }
                    ]
                },
                optionbar: {
                    title: {
                        text: '24小时各行业排行',
                        // left: 200,
                        textStyle: {
                            color: "#f7f7b6",
                            fontSize: 16,
                        },
                        // right: 140,
                        top: 100,
                        // left: 500,
                        // z: 0,
                        // right: "auto",
                    },
                    grid: {
                        // right: 10,
                        // bottom: 200,
                        left: 155,
                        top: 150,
                        // containLabel: true,
                        // height: 650,
                        // width: 600,
                    },
                    legend: {
                        top: 100,
                        right: 50,
                        data: ['项目数量'],
                        textStyle: {
                            color: "#f7f7b6",
                            fontSize: 14,
                        },
                    },
                    tooltip: {
                        // trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        },
                        position: "left"
                    },
                    toolbox: {
                        feature: {
                            saveAsImage: {
                                pixelRatio: 2,
                                backgroundColor: "#1D2A48"
                            },

                        },
                        iconStyle: {
                            borderColor: '#f7f7b6'
                        },
                        top: 100,
                        right: 10,
                    },
                    xAxis: {
                        // data: y_axis,
                        type: 'value',
                        // splitLine: false,
                        axisLabel: {
                            interval: 0,
                            textStyle: {
                                color: '#f7f7b6',
                                align: 'left',
                                fontSize: 14,

                            },
                        },
                        splitLine: {
                            show: false
                        },

                    },
                    yAxis: {
                        type: 'category',
                        inverse: true,
                        // nameGap: 16,
                        // splitLine: false,
                        data: ['aaa', 'bbb'],
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "black",
                            }
                        },

                        axisTick: {
                            show: true,
                            lineStyle: {
                                color: '#ddd'
                            }
                        },
                        axisLabel: {
                            // interval: 0,
                            margin: 150,
                            textStyle: {
                                color: '#f7f7b6',
                                align: 'left',
                                fontSize: 14,

                            },
                            rich: {
                                a: {
                                    color: '#ffffff',
                                    backgroundColor: '#f0515e',
                                    width: 20,
                                    height: 20,
                                    align: 'center',
                                    // borderRadius: 2,
                                },
                                b: {
                                    color: '#ffffff',
                                    backgroundColor: '#24a5cd',
                                    width: 20,
                                    height: 20,
                                    align: 'center',
                                    // borderRadius: 2,
                                }
                            },
                            formatter: function (params) {
                                if (parseInt(params.slice(0, 2)) < 5) {
                                    return [
                                        '{a|' + (parseInt(params.slice(0, 2)) + 1) + '}' + '  ' + params.slice(2, 8)
                                    ].join('\n')
                                } else {
                                    return [
                                        '{b|' + (parseInt(params.slice(0, 2)) + 1) + '}' + '  ' + params.slice(2, 8)
                                    ].join('\n')
                                }
                            }
                        },
                    },
                    color: ["#de6c90", "#edebef"],
                    dataZoom: [
                        {
                            showDetail: false,
                            // type: 'inside',
                            start: 0,
                            end: 30,
                            yAxisIndex: 0,
                            // width: 20,
                        },
                    ],
                    series: [
                        {
                            name: '项目数量',
                            type: 'bar',
                            // left: 600,
                            roam: false,
                            z: 1000,
                            visualMap: false,
                            data: [123, 155],
                            stack: '总量',
                            label: {
                                normal: {
                                    show: true,
                                    fontSize: 14,
                                    color: "#f7f7b6",
                                    textBorderColor: '#333',
                                    textBorderWidth: 2
                                }
                            },
                            animationDelay: function (idx) {
                                return idx * 10

                            }
                        },


                    ],
                    animationEasing: 'elasticOut',
                    // animationDelayUpdate: 1000,
                }
            }
        },
        methods: {

            cl: function (params) {
                var compare = (prop) => {
                    return (a, b) => {
                        return a[prop] < b[prop] ? 1 : -1
                    }
                }
                this.option.series[1].data = this.series['次分类'][params.data.name].sort(compare('value'));
                this.myChart.setOption(this.option, true);
            }
        },
        mounted() {
            // var waterMarkText = '广州绿网';
            // var canvas = document.createElement('canvas');
            // var ctx = canvas.getContext('2d');
            // canvas.width = canvas.height = 1000;
            // ctx.fillStyle = "#1f2b4a";
            // ctx.fillRect(0, 0, 1000, 1000);
            // ctx.textAlign = 'center';
            // ctx.fillStyle = "orange";
            // ctx.textBaseline = 'middle';
            // ctx.font = '30px Microsoft Yahei';
            // ctx.translate(50, 50);
            // // ctx.rotate(-Math.PI / 4);
            // ctx.fillText(waterMarkText, 1000, 1000);
            //
            // this.option.toolbox.feature.saveAsImage.backgroundColor = {
            //     // type: "patten",
            //     image: canvas,
            //     // repeat: 'repeat',
            //
            // };
            CreditPorjectRealtimeType().then(response => {

                var myChartbar = echarts.init(document.getElementById('realtime-type-bar'));

                // 指定图表的配置项和数据
                this.myChart = echarts.init(document.getElementById('realtime-porject-type'));
                var compare = (prop) => {
                    return (a, b) => {
                        return a[prop] < b[prop] ? 1 : -1
                    }
                }
                this.series = response.data['result'];
                response.data['result']['主分类'].sort(compare('value'));
                this.option.series[0].data = response.data['result']['主分类'];
                this.option.series[1].data = response.data['result']['次分类'][response.data['result']['主分类'][0]['name']].sort(compare('value'));


                var x_axis = [];
                var y_axis = [];
                for (var i = 0; i < response.data['result']['主分类'].length; i++) {
                    var names = response.data['result']['主分类'][i]['name']
                    if (i < 10) {
                        x_axis.push('0' + i + names);
                    } else {
                        x_axis.push(i + names);
                    }
                    y_axis.push(response.data['result']['主分类'][i]['value'])
                }
                this.optionbar.yAxis.data = x_axis;
                this.optionbar.series[0].data = y_axis;

                myChartbar.setOption(this.optionbar, true);

                // 使用刚指定的配置项和数据显示图表。
                this.myChart.setOption(this.option, true);

                this.myChart.on('click', this.cl);
            });

        },

    }
</script>

<style scoped>
    .content {

        height: 100vh;
        width: 1640px;
        /*background-color: #71a4d1;*/
        /*display: block;*/
    }

    #realtime-porject-type {
        width: 75%;
        height: 100vh;
        float: left;
        /*margin-left: 400px;*/
        /*margin-top: 30px;*/
        /*padding-top: 30px;*/
        /*background-color: #f7f7f7;*/
    }

    #realtime-type-bar {
        width: 25%;
        height: 100vh;
        float: right;
        /*margin-right: 30px;*/
        /*margin-top: 30px;*/
        /*padding-top: 30px;*/
        /*background-color: #f7f7f7;*/
    }

</style>